// ---------------------------------------------
// file: /src/Pages/ReservationForm/index.js
// ---------------------------------------------

import React, { useState, useEffect } from 'react';
import StepOne from '../../Steps/StepOne';
import StepTwo from '../../Steps/StepTwo';
import SuccessMessage from '../../Steps/StepThree';
import './css/form.css';

const ReservationForm = ({
  title, // no longer used for customization; dynamic title is computed below
  settings,
  generalSettings,
  fields,
  timeblocks,
  menu,
  mededeling,
  restaurantData,
  initialMenuTitle = '',
}) => {
  const initialFormData = {};
  fields.forEach((field) => {
    initialFormData[field.id] = '';
  });

  const [formData, setFormData] = useState(initialFormData);
  const [currentStep, setCurrentStep] = useState(1);
  const [expandedField, setExpandedField] = useState(null);

  // Dynamic title: only two options based on waitlist intent
  const dynamicTitle = formData.waitlist ? 'Inschrijven Wachtlijst' : 'Reserveer Nu';

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    if (type === 'number' && !/^\d*$/.test(value)) {
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (formData.date) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        time: '',
      }));
    }
  }, [formData.date]);

  const resetFormDataFields = (fieldsToReset) => {
    setFormData((prevFormData) => {
      const newFormData = { ...prevFormData };
      fieldsToReset.forEach((field) => {
        newFormData[field] = '';
      });
      return newFormData;
    });
  };

  const goToStep = (step, field) => {
    if (step === 1) {
      if (field === 'guest') {
        resetFormDataFields(['date', 'time']);
      } else if (field === 'date') {
        resetFormDataFields(['time']);
      }
    }
    setCurrentStep(step);
    setExpandedField(field || null);
  };

  return (
    <div className="reservation-form">
      {currentStep === 1 && (
        <StepOne
          title={dynamicTitle}
          timeblocks={timeblocks}
          generalNotification={settings?.generalNotification}
          formData={formData}
          handleChange={handleChange}
          resetFormDataFields={resetFormDataFields}
          setCurrentStep={goToStep}
          fields={fields}
          expandedField={expandedField}
          generalSettings={generalSettings}
          mededeling={mededeling}
          restaurantData={restaurantData}
        />
      )}

      {currentStep === 2 && (
        <StepTwo
          title={dynamicTitle}
          formData={formData}
          handleChange={handleChange}
          setCurrentStep={goToStep}
          fields={fields}
          menu={menu}
          /** new prop ↓ */
          initialMenuTitle={initialMenuTitle}
        />
      )}

      {currentStep === 3 && <SuccessMessage />}
    </div>
  );
};

export default ReservationForm;
